export function noop(): void {
  // This function should act like a placeholder,
  // so we don't need an implementation.
}
